// Live-verified strings (docs/spec/modules/calendar.md, Live-verified 2026-11-03) plus the spec's documented ones.
export const s = {
  pageTitle: "Calendar",
  navLabel: "Calendar",
  navAlt: "View Calendar",
  viewLabel: "CALENDAR",
  week: "Week",
  day: "Day",
  settings: "Calendar settings",
  teammates: "Teammates",
  previous: "Previous",
  next: "Next",
  zoomOut: "Zoom out",
  zoomIn: "Zoom in",
  planned: "Planned",
  pending: " (Pending)",
  timeGrid: "Calendar",
  // Entry modal
  addTitle: "Add time entry",
  editTitle: "Edit time entry",
  timeAndDate: "Time and date",
  durationInput: "Time duration input",
  startInput: "Start time",
  endInput: "End time",
  dateInput: "Date",
  description: "Description",
  descriptionPlaceholder: "What have you worked on?",
  project: "Project",
  task: "Task",
  selectProject: "Select project",
  searchProject: "Search Project or Client",
  noProject: "No project",
  tags: "Tags",
  addTags: "Add tags",
  searchTags: "Search tags",
  billable: "Billable",
  yes: "Yes",
  no: "No",
  cancel: "Cancel",
  add: "ADD",
  save: "SAVE",
  close: "Close",
  more: "More actions",
  split: "Split",
  duplicate: "Duplicate",
  delete: "Delete",
  nextDay: "+1",
  required: (field: string) => `${field} is required`,
  // Split
  splitTitle: "Split entry",
  splitAt: "Split at",
  splitHandle: "Split position",
  // Delete
  deleteTitle: "Delete",
  deleteBody: "Are you sure you want to delete this entry?",
  deleteConfirm: "DELETE",
  // Toasts
  added: "Time entry has been added",
  deleted: "Time entry deleted",
  undo: "UNDO",
  noLongerExists: "This time entry no longer exists",
  somethingWrong: "Something went wrong",
  connectFailed: "Couldn't connect your calendar. Please try again.",
  notConfigured: "Calendar integration isn't configured on this server.",
  tooManyCalendars: "You can enable up to 20 calendars.",
  // Teammates
  searchTeammates: "Search teammates",
  noTeammates: "No teammates found",
  statusActive: "Active",
  statusInactive: "Inactive",
  statusAll: "All",
  statusFilter: "Status",
  // Settings modal
  showWorkingDaysOnly: "Show working days only",
  googleCalendar: "Google Calendar",
  outlookCalendar: "Outlook Calendar",
  connectGoogle: "Connect Clockify to your Google account",
  connectOutlook: "Connect Clockify to your Microsoft account",
  connect: "CONNECT",
  connected: "Connected",
  disconnect: "Disconnect",
  closeUpper: "CLOSE",
  accountActions: "Account actions",
  // Events
  startTimer: "Start timer",
  copyAsEntry: "Copy as time entry",
  openInGoogle: "Open in Google Calendar",
  openInOutlook: "Open in Outlook",
  closePopover: "Close",
  // Blocks
  running: "Running",
  locked: "Locked",
  billableIcon: "Billable",
  entryLabel: (description: string, project: string, start: string, end: string, duration: string) =>
    `${description || "(no description)"}, ${project || "(no project)"}, ${start} to ${end}, ${duration}`,
  eventLabel: (title: string, start: string, end: string) => `${title}, ${start} to ${end}`,
} as const;
